export default __webpack_public_path__ + "static/media/bhxh-app-2.25fc720e.jpg";